// Stores universal configs
// 线上环境
const config = {
  production: true,
  urlScheme: process.env.URL_SCHEME || "https", // 前端url scheme
  host: process.env.HOST || "api.ent.kuban.io", // API域名
  socket_url: process.env.SOCKET_URL || "https://socket.ent.kuban.io",
  apiToken:
    "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6NzM3NSwidmVyc2lvbiI6MSwidHlwZSI6ImRhdGFfdmlzdWFsIn0.7-AQ0GR706Y2SS9zfS5LG_ZQkqk6LNxolUjm6gJbws8",
  fengmap: {
    key: "784ce34083545d12ea066be442670b8d", // branding的code name
    appname: "kubantest1" // branding在页面显示的名字
  },
  locationId: 2461 // 大屏对应的location
};

export default config;
